import {Injectable} from '@angular/core';
import {filter, map} from "rxjs/operators";
import {Subject, Subscription} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private subject$ = new Subject<any>();

  on(event: Events, action: any): Subscription {
    return this.subject$
      .pipe(
        filter((e: EmitEvent) => {
          return e.name === event;
        }),
        map((e: EmitEvent) => {
          return e.value;
        })
      )
      .subscribe(action);
  }

  emit(event: EmitEvent) {
    this.subject$.next(event);
  }
}

export class EmitEvent {

  constructor(public name: any, public value?: any) {
  }

}

export enum Events {
  CART_ITEM_UPDATE,
  USER_SIGNUP,
  OPEN_NAVBAR_LOGIN,
  FAQ,
  MEET_CHEFS,
  HOWTOBECOMECHEF,
  PLANYOURPLATE,
  EVENT_INITIALIZE,
  THANK_YOU
}
